'use client'

import { useEffect, useState } from 'react'
// import { Waypoint } from 'react-waypoint'
import Sticky from 'react-stickynode'
import { useWindowScroll } from 'react-use'

export default function HeaderSticky({
  sticky = false,
  children
}) {

  const [enabled, setEnabled] = useState(false)
  const { y } = useWindowScroll()
  useEffect(() => {
    const trigger = document.getElementById('header-sticky-trigger')
    if (trigger) {
      if (trigger.getBoundingClientRect().top <= 0) {
        setEnabled(true)
      } else {
        setEnabled(false)
      }
    } else {
      setEnabled(true)
    }
  }, [y])

  if (sticky) {
    return (
      <Sticky
        enabled={enabled}
        top={0}
        innerClass='bg-white transition-colors hover:z-[110]'
        innerActiveClass='z-[120] border-b-2 border-secondary'
      >
        {children}
      </Sticky>
    )
  }

  return children
}